import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { getLanguage } from "../../../localStorage";

const Language = () => {
  const { i18n, t } = useTranslation();
  const [selected, setSelected] = useState(null);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setSelected(lng);
  };

  useEffect(() => {
    const data = getLanguage();
    setSelected(data);
  }, []);

  return (
    <Fragment>
      <div>
        <Link className="txt-dark">
          <h6 className="text-uppercase">{selected}</h6>
        </Link>
        <ul className="language-dropdown onhover-show-div p-20">
          <li onClick={() => changeLanguage("en")}>
            <Link data-lng="en">
              <i className="flag-icon flag-icon-um"></i> {t("english")}
            </Link>
          </li>
          <li onClick={() => changeLanguage("es")}>
            <Link data-lng="es">
              <i className="flag-icon flag-icon-es"></i> {t("spanish")}
            </Link>
          </li>
        </ul>
      </div>
    </Fragment>
  );
};

export default Language;
